import React, { useState, useEffect, useContext } from 'react'
import { Button, FormControl, Modal, Typography, MenuItem, Select, InputLabel } from '@material-ui/core';
import { CustomerAccountContext } from '../contexts/customer-account-context'

const modalStyles = { 
    backgroundColor: 'white', 
    height: 225, 
    width: 400, 
    position: "fixed", 
    top: "50%", 
    left: "50%", 
    transform: "translate(-50%, -50%)",
    padding: "2rem"
}

export const EditAccountType = ({ isOpen, onClose, updateAccountType }) => {
    const [ newAccountType, setNewAccountType ] = useState('')
    const customerContext = useContext(CustomerAccountContext)
    const accountType = ['Production', 'POC', 'Prospect', 'Internal']

    useEffect(() => {
        setNewAccountType(customerContext.account.type)
    }, [])

    const handleOnSubmit = async (e) => {
        e.preventDefault()
        await updateAccountType(newAccountType)
        await customerContext.refreshCustomer()
        onClose()
    }

    const handleOnChange = (e) => {
        const newType = e.target.value
        setNewAccountType(newType)
    }

    const handleOnClose = () => {
        setNewAccountType(customerContext.account.type)
        onClose()
    }

    return (
        <Modal open={isOpen} onClose={handleOnClose}>
            <div style={modalStyles}>
                <Typography variant="h5" color="primary">Edit Account Type</Typography>
                <form onSubmit={handleOnSubmit}>
                    <FormControl fullWidth>
                        <div style={{ margin: "2rem 0" }}>
                            <InputLabel style={{ top: 25 }} id="account-type-select-label">Select New Account Type *</InputLabel>
                            <Select
                                labelId='account-type-select-label'
                                name='accountType'
                                required
                                label='Select New Account Type'
                                onChange={handleOnChange}
                                fullWidth={true}
                                value={newAccountType}
                            >
                                {accountType.map((type) => (
                                    <MenuItem key={type} value={type} selected={newAccountType === type ? true : false}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div style={{display: "flex", justifyContent: "flex-end", width: "100%"}}>
                            <Button
                                color="primary"
                                disableElevation
                                onClick={handleOnClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit" 
                                variant="contained"
                                color="primary"
                                disableElevation
                            >
                                Update
                            </Button>
                        </div>
                    </FormControl>
                </form>
            </div>
        </Modal>
    )
}
